import React, { FC } from 'react'
import { TextField, FormField, TextInput } from '../..'
import { TextFieldTypes } from 'views/components/atoms/TextField/text-field.types'
import { formUtils } from 'utils/index'

type Props = {
  values?: {
    addressLine1: string
    addressLine2: string
    city: string
    province: string
    postalCode: string
    country: string
  }
  errors?: any
  touched?: any
  submitCount?: number
  disableFields?: boolean
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  handleBlur: (event: React.FocusEvent<HTMLInputElement>) => void
}

const emptyValues = {
  addressLine1: '',
  addressLine2: '',
  city: '',
  province: '',
  postalCode: '',
  country: '',
}

const AddressFormGroup: FC<Props> = ({
  values = emptyValues,
  errors,
  touched,
  submitCount,
  disableFields,
  handleChange,
  handleBlur,
}) => {
  const getFieldError = formUtils.getFieldError(submitCount, touched, errors)

  return (
    <>
      <div className="rbn--row">
        <div className="rbn--col-md-8">
          <FormField>
            <TextField
              inputComponent={
                <TextInput
                  type={TextFieldTypes.text}
                  name="address.addressLine1"
                  value={values?.addressLine1}
                  disabled={disableFields}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
              }
              label="Address line 1"
              error={getFieldError('address.addressLine1')}
            />
          </FormField>
        </div>
      </div>
      <div className="rbn--row">
        <div className="rbn--col-md-4">
          <FormField>
            <TextField
              inputComponent={
                <TextInput
                  type={TextFieldTypes.text}
                  name="address.addressLine2"
                  value={values?.addressLine2}
                  disabled={disableFields}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
              }
              label="Address line 2"
              error={getFieldError('address.addressLine2')}
            />
          </FormField>
        </div>
        <div className="rbn--col-md-4">
          <FormField>
            <TextField
              inputComponent={
                <TextInput
                  type={TextFieldTypes.text}
                  name="address.city"
                  value={values.city}
                  disabled={disableFields}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
              }
              label="City / municipality"
              error={getFieldError('address.city')}
            />
          </FormField>
        </div>
      </div>
      <div className="rbn--row">
        <div className="rbn--col-md-3">
          <FormField>
            <TextField
              inputComponent={
                <TextInput
                  type={TextFieldTypes.text}
                  name="address.province"
                  value={values.province}
                  disabled={disableFields}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
              }
              label="Province"
              error={getFieldError('address.province')}
            />
          </FormField>
        </div>
        <div className="rbn--col-md-2">
          <FormField>
            <TextField
              inputComponent={
                <TextInput
                  type={TextFieldTypes.text}
                  name="address.postalCode"
                  value={values.postalCode}
                  disabled={disableFields}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
              }
              label="Postal code"
              error={getFieldError('address.postalCode')}
            />
          </FormField>
        </div>
        <div className="rbn--col-md-3">
          <FormField>
            <TextField
              inputComponent={
                <TextInput
                  type={TextFieldTypes.text}
                  name="address.country"
                  value={values.country}
                  disabled={disableFields}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
              }
              label="Country"
              error={getFieldError('address.country')}
            />
          </FormField>
        </div>
      </div>
    </>
  )
}

export default AddressFormGroup
